module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/icon_01-f0ca37653ad0658b46fe1e2437de3c34.png";